/**
 * MasterPowerLogoIcon - The MasterPower mark: a yellow disc with a black
 * lightning bolt in the center (no outer lens shell). Fixed colors; the
 * connection status (green/red/grey) is conveyed by the surrounding status pill.
 */

interface MasterPowerLogoIconProps {
  /** Icon size in pixels (default 22 — fills the 32px status pill while keeping a colored margin) */
  size?: number;
  /** Dim the icon (greyed + slightly translucent) to signal the "not in use" state */
  dimmed?: boolean;
  /** Additional inline styles */
  style?: React.CSSProperties;
}

export const MasterPowerLogoIcon = ({ size = 22, dimmed = false, style }: MasterPowerLogoIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    style={{
      display: 'block',
      flexShrink: 0,
      // Grey veil over the icon when not in use: desaturate + fade
      filter: dimmed ? 'grayscale(1)' : undefined,
      opacity: dimmed ? 0.45 : undefined,
      ...style,
    }}
  >
    {/* Yellow outer ring, black inner disc */}
    <circle cx="12" cy="12" r="11" fill="#000000" stroke="#FACC15" strokeWidth="2" />
    {/* Yellow lightning bolt centered on the disc */}
    <path
      d="M13 4 L7 13 h4 l-1 7 6 -9 h-4 z"
      fill="#FACC15"
    />
  </svg>
);
